const isFunction = obj => {
  return !!(obj && obj.constructor && obj.call && obj.apply);
};

const createActionHandler = ignore => {
  // redux-ignore higher order reducer
  const handleAction = function handleAction(reducer) {
    let actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const set = Array.isArray(actions) ? new Set(actions) : undefined;
    const predicate = isFunction(actions) ? actions : action => set.has(action.type);
    const initialState = reducer(undefined, {});
    return function () {
      let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      let action = arguments.length > 1 ? arguments[1] : undefined;

      if (predicate(action)) {
        return ignore ? state : reducer(state, action);
      }

      return ignore ? reducer(state, action) : state;
    };
  };

  return handleAction;
};

export const ignoreActions = createActionHandler(true);
export const filterActions = createActionHandler(false);
export default ignoreActions; // /redux-ignore